/**
 * Desktop sidebar filters: the "Filters" title is a toggle (x when open, + when closed).
 * The state lives on <html> so it survives the section re-renders that happen when filters change.
 */
(() => {
  const KEY = 'ygpoyf-filters-closed';
  const root = document.documentElement;

  const sync = () => {
    const closed = root.hasAttribute('data-filters-closed');
    document.querySelectorAll('[data-facets-collapse]').forEach((btn) => {
      btn.setAttribute('aria-expanded', String(!closed));
    });
  };

  try {
    if (sessionStorage.getItem(KEY) === '1') root.setAttribute('data-filters-closed', '');
  } catch (e) {}

  // "Birthday for" (Male / Female / Kids) only shows once Birthday is picked under Occasion.
  const syncConditional = () => {
    const occasion = document.querySelectorAll('input[name="filter.p.m.custom.occasion"]');
    const birthdayFor = document.querySelectorAll('input[name="filter.p.m.custom.birthday_for"]');
    if (!birthdayFor.length) return;
    const birthdayChosen = Array.from(occasion).some((input) => input.checked && input.value === 'Birthday');
    const alreadyFiltered = Array.from(birthdayFor).some((input) => input.checked);
    const show = birthdayChosen || alreadyFiltered;
    birthdayFor.forEach((input) => {
      const item = input.closest('.facets__item');
      if (item) item.hidden = !show;
    });
  };

  // Keep the "Filters" title row as wide as the sidebar so the x sits on the sidebar's right edge.
  const measure = () => {
    if (root.hasAttribute('data-filters-closed')) return;
    const sidebar = document.querySelector('.facets-block-wrapper--vertical:not(#filters-drawer)');
    const width = sidebar ? sidebar.getBoundingClientRect().width : 0;
    if (width > 0) root.style.setProperty('--facets-sidebar-width', `${Math.round(width)}px`);
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('[data-facets-collapse]')) return;
    const toggle = () => {
      const closed = root.toggleAttribute('data-filters-closed');
      try {
        sessionStorage.setItem(KEY, closed ? '1' : '0');
      } catch (e) {}
      sync();
    };
    // Crossfade the layout change over 0.3s where supported (see base.css); otherwise just toggle.
    if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      measure();
      // The theme turns the root view transition off (view-transition-name: none); switch it on just for this change.
      root.classList.add('filters-transition');
      const transition = document.startViewTransition(toggle);
      transition.finished.finally(() => root.classList.remove('filters-transition'));
    } else {
      toggle();
    }
  });

  window.addEventListener('resize', measure);

  // Section re-renders replace the buttons, so keep aria-expanded correct afterwards.
  new MutationObserver(() => {
    sync();
    measure();
    syncConditional();
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('change', syncConditional);
  sync();
  measure();
  syncConditional();
})();
